import {User} from '@eitje/api'
import {Avatar, Select, Layout, Text} from '~/components'
import _ from 'lodash'

const emptyPlaceholderProps = {
	animation: 'waving-people',
	name: 'no_users_in_filters',
}

const ITEM_HEIGHT = 48

export const UserList = ({users, userIds, ...rest}) => {
	if (userIds) return <UserListWithIds userIds={userIds} {...rest} />
	return <InnerUserList users={users} {...rest} />
}

const UserListWithIds = ({userIds, ...rest}) => {
	const users = User.useWhere(userIds)
	return <InnerUserList users={users} {...rest} />
}

const InnerUserList = ({value, ItemComponent = UserListItem, onItemClick = _.noop, users, ...rest}) => {
	const title = {t: 'common.team_members', countSuffix: users.length}

	return (
		<Select
			title={title}
			emptyPlaceholderProps={emptyPlaceholderProps}
			{...rest}
			items={users}
			labelField="full_name"
			value={value}
			onChange={onItemClick}
			ItemComponent={ItemComponent}
			itemHeight={ITEM_HEIGHT}
		/>
	)
}

const UserListItem = ({item}) => {
	return (
		<Layout gap={12} width="full">
			<Avatar user={item} />
			<Text truncate noTextSelect>
				{item.full_name}
			</Text>
		</Layout>
	)
}
